import { MODELS } from '@antv/xflow-core';
export var CONTEXT_MENU_MODEL;
(function (CONTEXT_MENU_MODEL) {
    CONTEXT_MENU_MODEL.id = 'CONTEXT_MENU_MODEL';
    CONTEXT_MENU_MODEL.useValue = MODELS.useModelValueUtil(CONTEXT_MENU_MODEL.id);
    CONTEXT_MENU_MODEL.getModel = MODELS.getModelUtil(CONTEXT_MENU_MODEL.id);
})(CONTEXT_MENU_MODEL || (CONTEXT_MENU_MODEL = {}));
//# sourceMappingURL=interface.js.map